import { Backdrop, CircularProgress } from '@mui/material'

type Props = {
  open: boolean
}

export const BackdropLoader = (props: Props) => {
  return (
    <Backdrop sx={{ color: '#FFF', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={props.open}>
      <CircularProgress color="inherit" size={64} thickness={6} />
    </Backdrop>
  )
}
